import React from "react";
import { useNavigate } from "react-router-dom";
import useScrollReveal from "../../hooks/useScrollReveal";
import Nav from "../site/Nav";
import SEO from "../site/SEO";
import VideoBanner from "../site/VideoBanner";
import HomeHero from "../site/home/HomeHero";
import ProblemLeaks from "../site/home/ProblemLeaks";
import RevenueLeakAuditSection from "../site/home/RevenueLeakAuditSection";
import TwoPath from "../site/TwoPath";
import AuditProcess from "../site/home/AuditProcess";
import WhatYouReceive from "../site/home/WhatYouReceive";
import IcpSection from "../site/home/IcpSection";
import FinalCta from "../site/FinalCta";
import Footer from "../site/Footer";

export default function HomePage() {
  useScrollReveal();
  const navigate = useNavigate();

  return (
    <div className="bg-sand-100 text-ink min-h-screen" data-testid="home-page">
      <SEO page="/" />
      <Nav />
      <main>
        <VideoBanner />
        {/* Audit-first conversion path: Hero → Problem → Audit → Build paths →
            Process → Proof → ICP → Final CTA. Retired sections (AI Intelligence,
            ROI, Stack, Scenarios, Trust, Lead-to-Cash map) remain in the
            codebase for future pages. */}
        <HomeHero />
        <ProblemLeaks />
        <RevenueLeakAuditSection />
        <TwoPath />
        <AuditProcess />
        <WhatYouReceive />
        <IcpSection />
        <div className="pt-6 sm:pt-10">
          <FinalCta
            eyebrow="The Next Step"
            headline="There's a leak between your leads and your revenue."
            body="Let's find it, map it, and build the system to close it."
            primaryLabel="Get a Revenue Leak Audit"
            onPrimary={() => navigate("/revenue-leak-audit")}
            secondaryLabel="Book a Consultation"
            secondaryHref="/book"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}
